// @ts-nocheck
import React, {Component} from 'react';
import AddHCPP1 from './AddHcp_P1'
import AddHCPP2 from './AddHcp_P2'
import AddHCPP3 from './AddHcp_P3'
import AddHCPSuccess from './AddHcpSuccess'
import Popup from '../../../globalcomponents/Popup';



class AddHcp extends Component {
    constructor(props) {
        super(props);
        this.state = {
            page: [],
            activePage: 0,
            info: {},
            loaded: false
        };
    }

    componentDidMount() {
        this.setState({
            page: [
                <AddHCPP1 user={this.props.user} info={this.state.info} nextPage={this.nextPage.bind(this)} close={this.props.close} />,
                <AddHCPP2 user={this.props.user} info={this.state.info} nextPage={this.nextPage.bind(this)} close={this.props.close} />,
                <AddHCPP3 user={this.props.user} info={this.state.info} submit={this.props.submit} nextPage={this.nextPage.bind(this)} close={this.props.close} />,
                <AddHCPSuccess close={this.props.close} />,
            ],
            loaded: true
        })
    }

    nextPage(i, info) {
        if (info !== undefined) {
            let temp = this.state.info
            Object.assign(temp, info)
            this.setState({
                activePage: i,
                info: temp
            });
        }
        else {
            this.setState({
                activePage: i
            });
        }
    }

    render() {
        return (
            <div>
                {this.state.loaded > 0 ? <Popup component={this.state.page[this.state.activePage]} /> : ""}
            </div>
        )
    }
}

export default AddHcp;
